module.exports = __webpack_public_path__ + "assets/img/progress-50.svg";